import { Redirect, Route, Switch } from 'react-router-dom';
import PrivateRoute from '../constants/PrivateRoute';
import CartPage from '../pages/CartPage';
import CategoriesPage from '../pages/CategoriesPage';
import CouponCartPage from '../pages/CouponCartPage/CouponCartPage';
import CouponConfirmedPage from '../pages/CouponsPage/CouponConfirmedPage/CouponConfirmedPage';
import Coupons from '../pages/CouponsPage/Coupons';
import SmsCodeConfirmation from '../pages/SelfServicePage/ConfirmIdentity/SmsCodeConfirmation';
import FinishRegistrationPage from '../pages/SelfServicePage/FinishRegistrationPage/FinishRegistrationPage';
import IdentificationConfirmPage from '../pages/SelfServicePage/IdentificationConfirmPage/IdentificationConfirmPage';
import MSignatureLogin from '../pages/SelfServicePage/LoginOptions/MSignatureLogin';
import SmartIdLogin from '../pages/SelfServicePage/LoginOptions/SmartIdLogin';
import PasswordResetFormPage from '../pages/SelfServicePage/PasswordReset/PasswordResetForm/PasswordResetFormPage';
import PasswordResetPage from '../pages/SelfServicePage/PasswordReset/PasswordResetPage';
import RegisterPage from '../pages/SelfServicePage/Registration/RegisterPage';
import RegisterTermsPage from '../pages/SelfServicePage/Registration/RegisterTermsPage';
import SelfService from '../pages/SelfServicePage/SelfServicePage';
import AccountCredentialsEdit from '../pages/SelfServicePage/UserAccountPage/AccountManagment/AccountCredentialsEdit/AccountCredentialsEdit';
import AccountInfoEdit from '../pages/SelfServicePage/UserAccountPage/AccountManagment/AccountInfoEdit/AccountInfoEdit';
import Agreements from '../pages/SelfServicePage/UserAccountPage/AccountManagment/Agreements/Agreements';
import AuthorizedPersons from '../pages/SelfServicePage/UserAccountPage/AccountManagment/AuthorizedPersons/AuthorizedPersons';
import AuthorizedPersonsConfirmation from '../pages/SelfServicePage/UserAccountPage/AccountManagment/AuthorizedPersonsConfirmations/AuthorizedPersonsConfirmation';
import AmisSync from '../pages/SelfServicePage/UserAccountPage/Administration/AmisSync/AmisSync';
import AmisSyncLogDetails from '../pages/SelfServicePage/UserAccountPage/Administration/AmisSyncLogs/AmisSyncLogDetails';
import AmisSyncLogs from '../pages/SelfServicePage/UserAccountPage/Administration/AmisSyncLogs/AmisSyncLogs';
import ConsentLogDetails from '../pages/SelfServicePage/UserAccountPage/ConsentsChanges/ConsentLogDetails/ConsentLogDetails';
import ConsentLogs from '../pages/SelfServicePage/UserAccountPage/ConsentsChanges/ConsentLogs';
import FailedRegistrations from '../pages/SelfServicePage/UserAccountPage/FailedRegistrations/FailedRegistrations';
import LogDetails from '../pages/SelfServicePage/UserAccountPage/Logs/LogDetails/LogDetails';
import Logs from '../pages/SelfServicePage/UserAccountPage/Logs/Logs';
import PopupWindow from '../pages/SelfServicePage/UserAccountPage/Administration/PopupWindow/PopupWindow';
import RegistrationList from '../pages/SelfServicePage/UserAccountPage/Registrations/RegistrationList/RegistrationList';
import RegistrationTab from '../pages/SelfServicePage/UserAccountPage/Registrations/RegistrationTab/RegistrationTab';
import UserAccountPage from '../pages/SelfServicePage/UserAccountPage/UserAccountPage';
import VisitDetailsComponent from '../pages/SelfServicePage/UserAccountPage/Visits/VisitDetailsComponent';
import VisitsComponent from '../pages/SelfServicePage/UserAccountPage/Visits/VisitsComponent';
import VisitE025Details from '../pages/SelfServicePage/UserAccountPage/VisitsSubCategories/E025/VisitE025Details';
import VisitE025List from '../pages/SelfServicePage/UserAccountPage/VisitsSubCategories/E025/VisitE025List';
import InstrumentalResearches from '../pages/SelfServicePage/UserAccountPage/VisitsSubCategories/InstrumentalResearches/InstrumentalResearches';
import InstrumentalResearchesTab from '../pages/SelfServicePage/UserAccountPage/VisitsSubCategories/InstrumentalResearches/InstrumentalResearchesTab';
import LabaratoryResearches from '../pages/SelfServicePage/UserAccountPage/VisitsSubCategories/LabaratoryResearches/LabaratoryResearches';
import LabaratoryResearchesTab from '../pages/SelfServicePage/UserAccountPage/VisitsSubCategories/LabaratoryResearches/LabaratoryResearchesTab';
import OtherVisits from '../pages/SelfServicePage/UserAccountPage/VisitsSubCategories/OtherVisits/OtherVisits';
import PrescriptionsComponent from '../pages/SelfServicePage/UserAccountPage/VisitsSubCategories/Prescriptions/PrescriptionsComponent';
import PrescriptionTabComponent from '../pages/SelfServicePage/UserAccountPage/VisitsSubCategories/Prescriptions/PrescriptionTabComponent';
import ReferralsComponent from '../pages/SelfServicePage/UserAccountPage/VisitsSubCategories/Referrals/ReferralsComponent';
import ReferralTabComponent from '../pages/SelfServicePage/UserAccountPage/VisitsSubCategories/Referrals/ReferralTabComponent';
import VaccinationDetails from '../pages/SelfServicePage/UserAccountPage/VisitsSubCategories/Vaccinations/VaccinationDetails';
import VaccinationsList from '../pages/SelfServicePage/UserAccountPage/VisitsSubCategories/Vaccinations/VaccinationsList';
import ServicePage from '../pages/ServicePage';
import ServicesPage from '../pages/ServicesPage';
import TransferPreviewPage from '../pages/TransferPreviewPage';
import TransferRequestPage from '../pages/TransferRequestPage';
import TransferSuccessPage from '../pages/TransferSuccessPage';
import UserSidebar from '../shared/UserSidebar/UserSidebar';
import PatientInfo from '../pages/SelfServicePage/UserAccountPage/Administration/PatientInfo/PatientInfo';
import LocalRegistration from '../pages/SelfServicePage/UserAccountPage/LocalRegistration/LocalRegistration';
import LocalRegistrationList from '../pages/SelfServicePage/UserAccountPage/LocalRegistration/LocalRegistrationList.js';
import LocalRegistrationDetails from '../pages/SelfServicePage/UserAccountPage/LocalRegistration/LocalRegistrationDetails';
import AmisRequestLogs from '../pages/SelfServicePage/UserAccountPage/Administration/AmisRequests/AmisRequestLogs';
import DoctorInformation from '../pages/SelfServicePage/UserAccountPage/Administration/DoctorInformation/DoctorInformation';
import Combined from '../pages/CombinedPage/CombinedPage';
import CombinedServicesCheckout from '../pages/CombinedPage/CombinedServicesCheckout/CombinedServicesCheckout';
import CombinedServicesCompleted from '../pages/CombinedPage/CombinedServicesCompleted/CombinedServicesCompleted';
import ComplexServiceList from '../pages/SelfServicePage/UserAccountPage/VisitsSubCategories/ComplexService/ComplexServiceList';
import PathologyResearches from '../pages/SelfServicePage/UserAccountPage/VisitsSubCategories/PathologyResearches/PathologyResearches';
import PathologyResearchesTab from '../pages/SelfServicePage/UserAccountPage/VisitsSubCategories/PathologyResearches/PathologyResearchesTab';
import ComplexServiceDetails from '../pages/SelfServicePage/UserAccountPage/VisitsSubCategories/ComplexService/ComplexServiceDetails';
import ConsentForms from '../pages/SelfServicePage/UserAccountPage/AccountManagment/ConsentForms/ConsentForms';
import ServiceInformation from '../pages/SelfServicePage/UserAccountPage/Administration/ServiceInformation/ServiceInformation.js';
import CouponHistory from '../pages/SelfServicePage/UserAccountPage/CouponHistory/CouponHistory.js';
import CouponHistoryDetails from '../pages/SelfServicePage/UserAccountPage/CouponHistory/CouponHistoryDetails.js';
import SpecialistRestrictions from '../pages/SelfServicePage/UserAccountPage/Administration/SpecialistRestrictions/SpecialistRestrictions.js';
import InsuranceCardList from '../pages/SelfServicePage/UserAccountPage/AccountManagment/Insurances/InsuranceCardList.js';
import InsuranceCardEdit from '../pages/SelfServicePage/UserAccountPage/AccountManagment/Insurances/InsuranceCardEdit.js';
import UpdatePhone from '../pages/SelfServicePage/FinishRegistrationPage/UpdatePhone.js';
import PopularSearchTitleMapping from '../pages/SelfServicePage/UserAccountPage/Administration/PopularSearchTitleMapping/PopularSearchTitleMapping.js';
import TestPage from '@/v2/pages/TestPage';
import UserAccoutLayout from '@/v2/components/UserAccountSidebar/UserAccountLayout';
import UserAccountMainPage from '@/v2/pages/UserAccountMainPage/UserAccountMainPage';
import MyVisitsPage from '@/v2/pages/UserAccountVisitsPage/MyVisitsPage';
import PrescriptionsPage from '@/v2/pages/UserAccountPrescriptionsPage/PrescriptionsPage';
import ChangePasswordPage from '@/v2/pages/UserAccountChangePasswordPage/ChangePasswordPage';
import ManageAgreementsPage from '@/v2/pages/UserAccountManageAgreementsPage/ManageAgreementsPage';
import ManageAuthorizedPersonsPage from '@/v2/pages/UserAccountManageAutorizedPersonsPage/ManageAuthorizedPersonsPage';
import E025Page from '@/v2/pages/UserAccountE025Page/E025Page';
import ReferralsPage from '@/v2/pages/UserAccountReferralsPage/ReferralsPage';
import InstrumentalResearchesPage from '@/v2/pages/UserAccountInstrumentalResearchesPage/InstrumentalResearchesPage';
import VaccinationsPage from '@/v2/pages/UserAccountVaccinationsPage/VaccinationsPage';
import LaboratoryResearchesPage from '@/v2/pages/UserAccountLaboratoryResearchesPage/LaboratoryResearchesPage';
import PathologyResearchesPage from '@/v2/pages/UserAccountPathologyResearchesPage/PathologyResearchesPage';
import ComplexServicesPage from '@/v2/pages/UserAccountComplexServicesPage/ComplexServicesPage';
import CouponsPage from '@/v2/pages/UserAccountCouponsPage/CouponsPage';
import VisitDetailsPage from '@/v2/pages/UserAccountVisitDetailsPage/VisitDetailsPage';
import PrescriptionDetailsPage from '@/v2/pages/UserAccountPrescriptionDetailsPage/PrescriptionDetailsPage';
import ReferralDetailsPage from '@/v2/pages/UserAccountReferralDetailsPage/ReferralDetailsPage';
import InstrumentalResearchDetailsPage from '@/v2/pages/UserAccountInstrumentalResearchDetailsPage/InstrumentalResearchDetailsPage';
import VaccinationDetailsPage from '@/v2/pages/UserAccountVaccinationDetailsPage/VaccinationDetailsPage';
import PathologyResearcheDetailsPage from '@/v2/pages/UserAccountPathologyResearcheDetailsPage/PathologyResearcheDetailsPage';
import ComplexServiceDetailsPage from '@/v2/pages/UserAccountComplexServiceDetailsPage/ComplexServiceDetailsPage';
import CouponDetailsPage from '@/v2/pages/UserAccountCouponDetailsPage/CouponDetailsPage';
import DutyDoctorPage from '@/v2/pages/UserAccountDutyDoctorPage/DutyDoctorPage';
import LaboratoryResearchDetailsPage from '@/v2/pages/UserAccountLaboratoryResearchDetailsPage/LaboratoryResearchDetailsPage';
import OtherVisitsPage from '@/v2/pages/UserAccountOtherVisitsPage/OtherVisitsPage';
import EditPersonalInfoPage from '@/v2/pages/UserAccountEditPersonalInfoPage/EditPersonalInfoPage';

function AppRoutes() {
  return (
    <Switch>
      <Route path="/" exact>
        <CategoriesPage />
      </Route>

      <Route path="/services/:categoryId/:id" exact>
        <ServicesPage />
      </Route>

      <Route path="/order/:workplaceId/:serviceId" exact>
        <ServicePage />
      </Route>

      <Route path="/order/:workplaceId/:serviceId/:timeSlotId/:isPaid" exact>
        <ServicePage />
      </Route>

      <Route path="/checkout" exact>
        <CartPage />
      </Route>

      <Route path="/couponcheckout" exact>
        <CouponCartPage />
      </Route>

      <Route path="/selfservice" exact>
        <SelfService />
      </Route>

      <PrivateRoute
        path="/account"
        components={[UserSidebar, UserAccountPage]}
        exact
      />

      <PrivateRoute
        path="/account/edit"
        components={[UserSidebar, AccountInfoEdit]}
        exact
      />

      <PrivateRoute
        path="/account/manage-agreements"
        components={[UserSidebar, Agreements]}
        exact
      />

      <PrivateRoute
        path="/account/manage-agreements/:success"
        components={[UserSidebar, Agreements]}
        exact
      />

      <PrivateRoute
        path="/account/insurance-cards"
        components={[UserSidebar, InsuranceCardList]}
        exact
      />

      <PrivateRoute
        path="/account/insurance-card-edit"
        components={[UserSidebar, InsuranceCardEdit]}
        exact
      />

      <PrivateRoute
        path="/account/manage-authorized-persons"
        components={[UserSidebar, AuthorizedPersons]}
        exact
      />

      <PrivateRoute
        path="/account/authorized-persons-confirmation"
        components={[AuthorizedPersonsConfirmation]}
      />

      <PrivateRoute
        path="/account/change-password"
        components={[UserSidebar, AccountCredentialsEdit]}
        exact
      />

      <PrivateRoute
        path="/account/visits"
        components={[UserSidebar, VisitsComponent]}
        exact
      />

      <Route path="/kompleksines-paslaugos" exact>
        <Combined />
      </Route>

      <Route path="/kompleksines-paslaugos/checkout" exact>
        <CombinedServicesCheckout />
      </Route>

      <Route path="/kompleksines-paslaugos/completed" exact>
        <CombinedServicesCompleted />
      </Route>
      <Route path="/kompleksines-paslaugos/completed/:orderId" exact>
        <CombinedServicesCompleted />
      </Route>

      <PrivateRoute
        path="/account/visit-details"
        components={[UserSidebar, VisitDetailsComponent]}
        exact
      />

      <PrivateRoute
        path="/account/instrumental-researches"
        components={[UserSidebar, InstrumentalResearches]}
        exact
      />

      <PrivateRoute
        path="/account/instrumental-research"
        components={[UserSidebar, InstrumentalResearchesTab]}
        exact
      />

      <PrivateRoute
        path="/account/labaratory-researches"
        components={[UserSidebar, LabaratoryResearches]}
        exact
      />

      <PrivateRoute
        path="/account/labaratory-research"
        components={[UserSidebar, LabaratoryResearchesTab]}
        exact
      />

      <PrivateRoute
        path="/account/prescriptions"
        components={[UserSidebar, PrescriptionsComponent]}
        exact
      />

      <PrivateRoute
        path="/account/prescription"
        components={[UserSidebar, PrescriptionTabComponent]}
        exact
      />

      <PrivateRoute
        path="/account/vaccinations"
        components={[UserSidebar, VaccinationsList]}
        exact
      />

      <PrivateRoute
        path="/account/vaccination"
        components={[UserSidebar, VaccinationDetails]}
        exact
      />

      <PrivateRoute
        path="/account/referrals"
        components={[UserSidebar, ReferralsComponent]}
        exact
      />

      <PrivateRoute
        path="/account/referral"
        components={[UserSidebar, ReferralTabComponent]}
        exact
      />

      <PrivateRoute
        path="/account/E025"
        components={[UserSidebar, VisitE025List]}
        exact
      />

      <PrivateRoute
        path="/account/E025-details"
        components={[UserSidebar, VisitE025Details]}
        exact
      />
      <PrivateRoute
        path="/account/complex-services"
        components={[UserSidebar, ComplexServiceList]}
        exact
      />
      <PrivateRoute
        path="/account/pathology-researches"
        components={[UserSidebar, PathologyResearches]}
        exact
      />

      <PrivateRoute
        path="/account/pathology-research"
        components={[UserSidebar, PathologyResearchesTab]}
        exact
      />
      <PrivateRoute
        path="/account/complex-service"
        components={[UserSidebar, ComplexServiceDetails]}
        exact
      />

      <PrivateRoute
        path="/account/registrations"
        components={[UserSidebar, RegistrationList]}
        exact
      />

      <PrivateRoute
        path="/account/registration"
        components={[UserSidebar, RegistrationTab]}
        exact
      />

      <PrivateRoute
        path="/account/failed-registrations"
        components={[UserSidebar, FailedRegistrations]}
        exact
      />

      <PrivateRoute
        path="/account/other-visits"
        components={[UserSidebar, OtherVisits]}
        exact
      />

      <PrivateRoute path="/logs" components={[UserSidebar, Logs]} exact />

      <PrivateRoute
        path="/popup"
        components={[UserSidebar, PopupWindow]}
        exact
      />

      <PrivateRoute
        path="/patientInfo"
        components={[UserSidebar, PatientInfo]}
        exact
      />

      <PrivateRoute
        path="/consentLogs"
        components={[UserSidebar, ConsentLogs]}
        exact
      />

      <PrivateRoute
        path="/doctorInformation"
        components={[UserSidebar, DoctorInformation]}
        exact
      />

      <PrivateRoute
        path="/popularSearchTitleMapping"
        components={[UserSidebar, PopularSearchTitleMapping]}
        exact
      />

      <PrivateRoute
        path="/serviceInformation"
        components={[UserSidebar, ServiceInformation]}
        exact
      />

      <PrivateRoute path="/sync" components={[UserSidebar, AmisSync]} exact />

      <PrivateRoute
        path="/log/details"
        components={[UserSidebar, LogDetails]}
        exact
      />

      <PrivateRoute
        path="/consentLog/details"
        components={[UserSidebar, ConsentLogDetails]}
        exact
      />

      <PrivateRoute
        path="/registration/local"
        components={[UserSidebar, LocalRegistration]}
        exact
      />

      <PrivateRoute
        path="/registration/local/list"
        components={[UserSidebar, LocalRegistrationList]}
        exact
      />

      <PrivateRoute
        path="/registration/local/details"
        components={[UserSidebar, LocalRegistrationDetails]}
        exact
      />

      <PrivateRoute
        path="/syncLogs"
        components={[UserSidebar, AmisSyncLogs]}
        exact
      />

      <PrivateRoute
        path="/amis/requests"
        components={[UserSidebar, AmisRequestLogs]}
        exact
      />

      <PrivateRoute
        path="/syncLog/details"
        components={[UserSidebar, AmisSyncLogDetails]}
        exact
      />
      <PrivateRoute
        path="/account/consent-forms"
        components={[UserSidebar, ConsentForms]}
        exact
      />

      <PrivateRoute
        path="/account/user-coupons"
        components={[UserSidebar, CouponHistory]}
        exact
      />

      <PrivateRoute
        path="/admin/restrictions"
        components={[UserSidebar, SpecialistRestrictions]}
        exact
      />

      <PrivateRoute
        path="/account/user-coupon/details"
        components={[UserSidebar, CouponHistoryDetails]}
        exact
      />

      <Route path="/login/smartid" exact>
        <SmartIdLogin />
      </Route>

      <Route path="/login/msignature" exact>
        <MSignatureLogin />
      </Route>

      <Route path="/verify/phone" exact>
        <SmsCodeConfirmation />
      </Route>

      <Route path="/dovanu-kuponai" exact>
        <Coupons />
      </Route>

      <Route path="/coupon/checkout" exact>
        <CouponConfirmedPage />
      </Route>

      <Route path="/coupon/checkout/:orderId" exact>
        <CouponConfirmedPage />
      </Route>

      <Route path="/register" exact>
        <RegisterPage />
      </Route>

      <Route path="/terms" exact>
        <RegisterTermsPage />
      </Route>

      <Route path="/forgot-password" exact>
        <PasswordResetPage />
      </Route>

      <Route path="/change-password" exact>
        <PasswordResetFormPage />
      </Route>

      <Route path="/change-phone" exact>
        <UpdatePhone />
      </Route>

      <Route path="/register/info" exact>
        <FinishRegistrationPage />
      </Route>

      <Route path="/confirmIdentity" exact>
        <IdentificationConfirmPage />
      </Route>

      <Route path="/transfer-request" exact>
        <TransferRequestPage />
      </Route>
      <Route path="/transfer-request/preview" exact>
        <TransferPreviewPage />
      </Route>
      <Route path="/transfer-request/success" exact>
        <TransferSuccessPage />
      </Route>

      <Route path="/test" exact>
        <TestPage />
      </Route>

      <Route
        path="/userAccount"
        render={({ match }) => (
          <UserAccoutLayout>
            <Switch>
              {/* Default redirect */}
              <Route exact path={match.path}>
                <Redirect to={`${match.path}/personal-info`} />
              </Route>

              <Route
                path={`${match.path}/personal-info`}
                render={({ match: personalInfoMatch }) => (
                  <>
                    <PrivateRoute
                      exact
                      path={personalInfoMatch.path}
                      component={UserAccountMainPage}
                    />
                    <PrivateRoute
                      path={`${personalInfoMatch.path}/change-password`}
                      component={ChangePasswordPage}
                    />
                    <PrivateRoute
                      path={`${personalInfoMatch.path}/manage-agreements`}
                      component={ManageAgreementsPage}
                    />

                    <PrivateRoute
                      path={`${personalInfoMatch.path}/edit`}
                      component={EditPersonalInfoPage}
                    />
                    <PrivateRoute
                      path={`${personalInfoMatch.path}/manage-authorized-persons`}
                      component={ManageAuthorizedPersonsPage}
                    />
                  </>
                )}
              />

              <PrivateRoute
                exact
                path={`${match.path}/visits`}
                component={MyVisitsPage}
              />
              <PrivateRoute
                exact
                path={`${match.path}/visits/details`}
                component={VisitDetailsPage}
              />

              <PrivateRoute path={`${match.path}/E025`} component={E025Page} />

              <PrivateRoute
                exact
                path={`${match.path}/prescriptions`}
                component={PrescriptionsPage}
              />

              <PrivateRoute
                exact
                path={`${match.path}/prescriptions/details`}
                component={PrescriptionDetailsPage}
              />

              <PrivateRoute
                exact
                path={`${match.path}/referrals`}
                component={ReferralsPage}
              />

              <PrivateRoute
                exact
                path={`${match.path}/referrals/details`}
                component={ReferralDetailsPage}
              />

              <PrivateRoute
                exact
                path={`${match.path}/instrumental-researches`}
                component={InstrumentalResearchesPage}
              />

              <PrivateRoute
                exact
                path={`${match.path}/instrumental-researches/details`}
                component={InstrumentalResearchDetailsPage}
              />

              <PrivateRoute
                exact
                path={`${match.path}/vaccinations`}
                component={VaccinationsPage}
              />

              <PrivateRoute
                exact
                path={`${match.path}/vaccinations/details`}
                component={VaccinationDetailsPage}
              />

              <PrivateRoute
                exact
                path={`${match.path}/laboratory-researches`}
                component={LaboratoryResearchesPage}
              />

              <PrivateRoute
                exact
                path={`${match.path}/laboratory-researches/details`}
                component={LaboratoryResearchDetailsPage}
              />

              <PrivateRoute
                exact
                path={`${match.path}/laboratory-researches/details`}
                component={LaboratoryResearchDetailsPage}
              />

              <PrivateRoute
                exact
                path={`${match.path}/pathology-researches`}
                component={PathologyResearchesPage}
              />
              <PrivateRoute
                exact
                path={`${match.path}/other`}
                component={OtherVisitsPage}
              />

              <PrivateRoute
                exact
                path={`${match.path}/pathology-researches/details`}
                component={PathologyResearcheDetailsPage}
              />

              <PrivateRoute
                exact
                path={`${match.path}/complex-services`}
                component={ComplexServicesPage}
              />

              <PrivateRoute
                exact
                path={`${match.path}/complex-services/details`}
                component={ComplexServiceDetailsPage}
              />

              <PrivateRoute
                exact
                path={`${match.path}/Coupons`}
                component={CouponsPage}
              />

              <PrivateRoute
                exact
                path={`${match.path}/Coupons/details`}
                component={CouponDetailsPage}
              />

              <PrivateRoute
                exact
                path={`${match.path}/duty-doctor`}
                component={DutyDoctorPage}
              />

              <PrivateRoute
                path={`${match.path}/logs`}
                components={[Logs]}
                exact
              />

              <PrivateRoute
                path={`${match.path}/popup`}
                components={[PopupWindow]}
                exact
              />

              <PrivateRoute
                path={`${match.path}/doctorInformation`}
                components={[DoctorInformation]}
                exact
              />

              <PrivateRoute
                path={`${match.path}/serviceInformation`}
                components={[ServiceInformation]}
                exact
              />

              <PrivateRoute
                path={`${match.path}/admin/restrictions`}
                components={[SpecialistRestrictions]}
                exact
              />
              <PrivateRoute
                path={`${match.path}/popularSearchTitleMapping`}
                components={[PopularSearchTitleMapping]}
                exact
              />
              <PrivateRoute
                path={`${match.path}/patientInfo`}
                components={[PatientInfo]}
                exact
              />
              <PrivateRoute
                path={`${match.path}/sync`}
                components={[AmisSync]}
                exact
              />

              <PrivateRoute
                path={`${match.path}/syncLogs`}
                components={[AmisSyncLogs]}
                exact
              />
              <PrivateRoute
                path={`${match.path}/consentLogs`}
                components={[ConsentLogs]}
                exact
              />
              <PrivateRoute
                path={`${match.path}/amis/requests`}
                components={[AmisRequestLogs]}
                exact
              />
            </Switch>
          </UserAccoutLayout>
        )}
      />

      <Redirect to="/"></Redirect>
    </Switch>
  );
}

export default AppRoutes;
